
// import React from "react";
// import DefaultDashboard from "./DefaultDashboard";

// const Dashboard = () => {
//   return <DefaultDashboard />;
// };

// export default Dashboard;



// src/Pages/DashboardManagment/Dashboard.jsx
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getUserRole, isSplitLeadVendor } from "../../Utils/role";
import SplitVendorDashboard from "./SplitVendorDashboard";
import DefaultDashboard from "./DefaultDashboard";
import AdminDashboard from "./AdminDashboard";
import VendorRouter from "./VendorRouter";

const Dashboard = () => {
  const role = getUserRole();
  const { permissions } = useSelector((state) => state.auth);

  // Debug
  useEffect(() => {
  }, [role, permissions]);

  if (isSplitLeadVendor()) return <SplitVendorDashboard />;

  if (role === "admin") return <AdminDashboard />;

  if (role === "vendor" || role === "vender" || role === "staff") {
    return <VendorRouter permissions={permissions} />;
  }

  return <DefaultDashboard />;
};

export default Dashboard;